import {AdminsService} from "@/services/admins-service";

export enum CRMEvent {
	CRM_EVENT_REVIEW_MESSAGE_SENT = 1,
	CRM_EVENT_INITIAL_SP_MAIL_SENT = 2,
	CRM_EVENT_SP_MAIL_SENT = 3,
}

export class CRM {
	public id:number = 0;
	public eventId:CRMEvent = CRMEvent.CRM_EVENT_REVIEW_MESSAGE_SENT;
	public metadata:{[key:string]:string} = {};
	public adminId:number = 0;
	public companyId:number = 0;
	public userId:number = 0;
	public timeStamp:Date = new Date();

	public constructor(data?:any){
		if (!data) return;
		this.id = data.id;
		this.eventId = data.eventId;
		this.metadata = data.metadata;
		this.adminId = data.adminId;
		this.userId = data.userId;
		this.timeStamp = new Date(data.timeStamp);
	}

	public getJSON(){
		return {
			id: this.id,
			eventId: this.eventId,
			metadata: this.metadata,
			adminId: this.adminId,
			companyId: this.companyId,
			userId: this.userId,
			timeStamp: this.timeStamp.toJSON()
		};
	}

	public get asString():string{
		if (this.eventId == CRMEvent.CRM_EVENT_REVIEW_MESSAGE_SENT) {
			return "Review bericht verzonden";
		}
		if (this.eventId == CRMEvent.CRM_EVENT_INITIAL_SP_MAIL_SENT) {
			return `Initiële SP email verzonden naar ${this.metadata["email"]}`;
		}
		if (this.eventId == CRMEvent.CRM_EVENT_SP_MAIL_SENT) {
			return `SP email verzonden naar ${this.metadata["email"]}`;
		}
		return "Foute Event ID";
	}

	public get adminName():string{
		let admin = AdminsService.admins.find(a=>a.id == this.adminId);
		if (!admin){
			return "Geen";
		}
		return admin.name.split(" ")[0];
	}
}